<template>
  <div v-if="isPlayerVisible" class="stream-player">
    <template v-if="isLiveOnBothPlatforms">
      <div class="tab-container toggle-tabs">
        <button
          class="tab"
          type="button"
          aria-title="Display Mixer Stream"
          title="Display Mixer Stream"
          :class="`${activePlayer === 'mixer' ? 'tab-active' : ''}`"
          @click="setStreamPlayer('mixer')"
        >
          Mixer
        </button>
        <button
          class="tab"
          type="button"
          aria-title="Display Twitch Stream"
          title="Display Twitch Stream"
          :class="`${activePlayer === 'twitch' ? 'tab-active' : ''}`"
          @click="setStreamPlayer('twitch')"
        >
          Twitch
        </button>
      </div>
    </template>
    <div class="player-container">
      <button
        class="close-button"
        aria-title="Close Stream Player"
        title="Close Stream Player"
        @click="closeStreamPlayer()"
      >
        <Icon class="icon" :glyph="'close'" />
      </button>
      <Mixer
        v-if="activePlayer === 'mixer'"
        :channel="streamer.mixer"
        :height="'100%'"
        :width="'100%'"
      />
      <Twitch
        v-if="activePlayer === 'twitch'"
        :channel="streamer.twitch"
        :height="'100%'"
        :width="'100%'"
      />
    </div>
  </div>
</template>

<script>
import stream from '@/stream';
import { Icon, Mixer, Twitch } from '@/components';
export default {
  name: 'stream-player',
  components: {
    Icon,
    Mixer,
    Twitch
  },
  computed: {
    activePlayer() {
      return this.$store.state.streamPlayer === 'twitch' ? 'twitch' : 'mixer';
    },
    isLiveOnBothPlatforms() {
      return (
        this.$store.state.mixerLiveStatus && this.$store.state.twitchLiveStatus
      );
    },
    isPlayerVisible() {
      return this.$store.state.streamPlayerVisible;
    }
  },
  data() {
    return {
      streamer: {
        mixer: stream.mixer.name,
        twitch: stream.twitch.name
      }
    };
  },
  methods: {
    closeStreamPlayer() {
      this.$store.commit('toggleStreamPlayer', false);
      // this.$store.commit('changePlayer', '');
    },
    setStreamPlayer(newStreamPlayer) {
      let currentStreamPlayer = this.$store.state.streamPlayer;
      if (currentStreamPlayer === newStreamPlayer) return;
      this.$store.commit('changePlayer', newStreamPlayer);
    }
  }
};
</script>

<style lang="scss" scoped>
.stream-player {
  align-items: center;
  background-color: rgba(black, 0.65);
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 30px;
  position: absolute;
  width: 100%;
  z-index: 100;
}

.tab-container {
  color: #fff;
  display: flex;
  margin-bottom: 5px;
  @media all and (min-width: 768px) {
    margin-bottom: 15px;
  }
}

.tab {
  background-color: none;
  background: none;
  border: none;
  color: #a0a0a0;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 9px 12px;
  position: relative;
  text-align: center;
  width: 90px;
  transition: background-color 150ms ease-in-out;
  // transition: 300ms ease-in-out;
  .no-touch &:hover {
    background-color: rgba(#fff, 0.3);
    &:not(.tab-active) {
      color: #ccc;
    }
  }
  &::before,
  &::after {
    content: '';
    background-color: #fff;
    bottom: 0;
    height: 3px;
    position: absolute;
    width: 0;
    left: 0;
    right: 0;
    transition: 300ms ease-in-out;
    margin-left: auto;
    margin-right: auto;
  }
}

.tab-active {
  color: #fff;
  font-weight: 700;
  &::before {
    height: 3px;
    width: 50%;
    right: 50%;
  }
  &::after {
    height: 3px;
    width: 50%;
    left: 50%;
  }
}

.player-container {
  max-height: 100%;
  padding-left: 40px;
  padding-right: 40px;
  position: relative;
  width: 100%;
  @media all and (min-width: 768px) {
    padding-left: 30px;
    padding-right: 30px;
  }
}
.close-button {
  background-color: #b1b1b1;
  border: none;
  border-radius: 50%;
  box-shadow: 0 0 3px -1px rgba(#000, 3);
  cursor: pointer;
  height: 30px;
  padding: 2px;
  position: absolute;
  right: 25px;
  width: 30px;
  top: -15px;
  z-index: 100;

  @media all and (min-width: 768px) {
    right: 15px;
  }
}
.icon {
  fill: #0d274f;
  height: 100%;
  width: 100%;
}
</style>
